import {
  Module,
  VuexModule,
  getModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';
import store from '@/store';
import User from '@/models/User';
import * as SecurityApiRepository from '@/repositories/api/SecurityApiRepository';
import * as swal from 'sweetalert2';
import LoginForm from '@/models/forms/login/LoginForm';
import AuthenticationForm from '@/models/forms/login/AuthenticationForm';

@Module({ dynamic: true, namespaced: true, name: 'security', store })
class SecurityModule extends VuexModule {
  public user: User | null = JSON.parse(localStorage.getItem('Karum-SecurityModule-user') || 'null');
  public token: string | null = JSON.parse(localStorage.getItem('Karum-SecurityModule-token') || 'null');
  public authenticationToken: string | null =
    JSON.parse(localStorage.getItem('Karum-SecurityModule-authenticationToken') || 'null');
  public username: string | null = JSON.parse(localStorage.getItem('Karum-SecurityModule-username') || 'null');
  public password: string | null = JSON.parse(localStorage.getItem('Karum-SecurityModule-password') || 'null');

  get getUser(): User | null {
    return this.user;
  }

  get getAuthenticationToken(): string | null {
    return this.authenticationToken;
  }

  get getToken(): string | null {
    return this.token;
  }

  get getUsername(): string | null {
    return this.username;
  }

  get getPassword(): string | null {
    return this.password;
  }

  @Mutation
  public setUser(user: User | null) {
    this.user = user;

    localStorage.setItem('Karum-SecurityModule-user', JSON.stringify(user));
  }

  @Mutation
  public setAuthenticationToken(authenticationToken: string | null) {
    this.authenticationToken = authenticationToken;

    localStorage.setItem('Karum-SecurityModule-authenticationToken', JSON.stringify(authenticationToken));
  }

  @Mutation
  public setToken(token: string | null) {
    this.token = token;

    localStorage.setItem('Karum-SecurityModule-token', JSON.stringify(token));
  }

  @Mutation
  public setUsername(username: string | null) {
    this.username = username;

    localStorage.setItem('Karum-SecurityModule-username', JSON.stringify(username));
  }

  @Mutation
  public setPassword(password: string | null) {
    this.password = password;

    localStorage.setItem('Karum-SecurityModule-password', JSON.stringify(password));
  }

  // @ts-ignore
  @Action
  public async fetchUser() {
    const user = null;

    this.setUser(user);
  }

  // @ts-ignore
  @Action
  public async login(loginForm: LoginForm): Promise<boolean> {
    let response = {};

    const payload = {
      username: loginForm.email.value,
      password: loginForm.password.value,
    };

    try {
      response = await SecurityApiRepository.login(payload);
    } catch (e) {
      // @ts-ignore
      swal.fire({
        type: 'error',
        position: 'top-end',
        title: 'Une erreur est survenue',
        showConfirmButton: !1,
        timer: 1500,
      });
    }

    if (response.hasOwnProperty('error')) {
      // @ts-ignore
      swal.fire({
        type: 'error',
        position: 'top-end',
        title: 'Erreur',
        // @ts-ignore
        text: response.error.message ? response.error.message : '',
        showConfirmButton: !1,
        timer: 1500,
      });
    }

    if (response.hasOwnProperty('success')) {
      // @ts-ignore
      swal.fire({
        type: 'success',
        position: 'top-end',
        title: 'Felicitation',
        // @ts-ignore
        text: response.success.message ? response.success.message : '',
        showConfirmButton: !1,
        timer: 1500,
      });
      return true;
    }

    return false;
  }

  // @ts-ignore
  @Action
  public async authenticate(authenticationForm: AuthenticationForm) {
    let response;

    try {
      response = await SecurityApiRepository.authenticate(authenticationForm.token.value);
    } catch (e) {
      // @ts-ignore
      swal.fire({
        type: 'error',
        position: 'top-end',
        title: 'Une erreur est survenue',
        showConfirmButton: !1,
        timer: 1500,
      });
    }

    if (response && response.hasOwnProperty('error')) {
      // @ts-ignore
      swal.fire({
        type: 'error',
        position: 'top-end',
        title: 'Erreur',
        // @ts-ignore
        text: response.error.message ? response.error.message : '',
        showConfirmButton: !1,
        timer: 1500,
      });
    }

    if (response && response.hasOwnProperty('success')) {
      // @ts-ignore
      swal.fire({
        type: 'success',
        position: 'top-end',
        title: 'Felicitation',
        // @ts-ignore
        text: response.success.message ? response.success.message : '',
        showConfirmButton: !1,
        timer: 1500,
      });
      return true;
    }

    const token = response && response.hasOwnProperty('token') ? response.token : null;
    const user = response && response.hasOwnProperty('user') ? response.user : null;

    this.setToken(token);
    this.setUser(user);
  }
}

export default getModule(SecurityModule);
